import { BuilderAsset } from "../entities/BuilderAsset";
import { BuilderAssetService } from "../services/BuilderAssetService";
import { PreviewSlide } from "../pages/builder/editor/PreviewSlide";
import { ServerResponse } from "../services/server/OldWebClient";
import { PresentationExporter } from "../pages/builder/configuration/PresentationExporter";
import BackgroundImages from "../resources/BackgroundImages.json";
import { BuilderPreferences } from "../entities/BuilderPreferences";
import BackgroundImage from "../entities/BackgroundImage";

const images: BackgroundImage[] = BackgroundImages as any;

export const exportSlides = async (asset: BuilderAsset, previewSlides: PreviewSlide[], preferences: BuilderPreferences) => {
	const handleExport = async () => {
		const presentationTitle = asset.name;
		let preferredAspectRatio = asset.slideExporterAspectRatio;

		if (!preferredAspectRatio) {
			preferredAspectRatio = "16x9";
		}
		let fontColor = getFontColor().substring(1);

		if (asset.customSlideBackgroundImagePath) {
			let response = await BuilderAssetService.getCustomBackgroundImageForDownload(asset.id);

			if (ServerResponse.isSuccess(response)) {
				PresentationExporter.exportWithImageData(previewSlides, preferredAspectRatio, fontColor, presentationTitle, response.message);
			}
		} else {
			PresentationExporter.exportWithImagePath(previewSlides, preferredAspectRatio, fontColor, presentationTitle, getImageFullRes());
		}
	};

	const getImageFullRes = () => {
		const backgroundImage = getStockBackgroundImage();

		if (asset.slideExporterAspectRatio === "4x3") {
			return backgroundImage.standardImagePath;
		}
		return backgroundImage.widescreenImagePath;
	};

	const getStockBackgroundImage = () => {
		const { slideExporterSelectedGalleryImageId } = preferences;
		const selectedImage = images.find((image) => image.id === slideExporterSelectedGalleryImageId);
		return selectedImage ? selectedImage : images[0];
	};

	const getFontColor = () => {
		const { slideExporterSelectedGalleryImageId } = preferences;
		if (asset.customSlideBackgroundImagePath) {
			return "#FFFFFF";
		}

		const selectedImage = images.find((image) => image.id === slideExporterSelectedGalleryImageId);
		const backgroundImage = selectedImage ? selectedImage : images[0];

		return backgroundImage.fontColor;
	};
	handleExport();
};
